import { css } from '@emotion/css'

import { fontSize, spacing } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import { colors } from '../../../themes'

const styles = {
  card: css({
    flexDirection: 'column',
    fontSize: fontSize.medium,
  }),

  header: css({
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.mystic}`,
    padding: shorthandHelper([spacing.default, spacing.medium]),

    '& > * + *': {
      marginLeft: spacing.default,
      fontSize: fontSize.medium,
    },
  }),

  body: css({
    padding: spacing.medium,
  }),

  editButton: css({
    marginLeft: 'auto',
  }),
}

export default styles
